export default "__VITE_ASSET__DS9e14Lo__"